/*
 * @Author: linhao hao.lin@biz-united.com.cn
 * @Date: 2026-06-11 17:15:54
 * @LastEditors: linhao hao.lin@biz-united.com.cn
 * @LastEditTime: 2026-07-15 16:36:37
 * @FilePath: \crm-product\src\views\performanceCalculation\views\result_statement\monthly_terminal_performance_report\form\detail.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import BasePage from '@/found/components/table_page';
import ScanDetailForm from '../scanDetail/detail.vue';

export default {
  name: 'detail',
  extends: BasePage,
  props: {
    paramsProps: Object,
  },
  components: {
    ScanDetailForm,
  },
  data() {
    return {
      params: {
        mainId: this.paramsProps.mainId,
      },
    };
  },
  methods: {
    // 控制按钮显示
    clickVisible({ row }) {
      const {
        remarks,
      } = row;
      if (remarks === '导入') {
        return false;
      }
      return true;
    },
    setColumn(col) {
      const item = col;
      if (item.field === 'checkTypeseq') {
        item.title = '序号';
        item.width = '50';
      }
      return item;
    },
    modalClick({
      val,
      row,
    }) {
      if (val.code === 'scan_details') {
        this.formName = 'ScanDetailForm';
        this.formConfig = {
          mainId: row.id,
        };
        this.modalConfig.title = '扫码明细';
        this.openFull();
      }
    },
  },
  created() {
    this.getConfigList('detail-list');
  },
};
